export const operatorRoute = {
  path: "/operator",
  name: "op_admin",
  redirect: '/operator/users',
  component: () => import('../pages/operator/index.vue'),
  meta: {
    requiresAUserType: 'admin'
  },
  children: [
    {
      path: "dashboard",
      name: "op_dashboard",
      component: () => import('../pages/operator/dashboard/index.vue'),
      meta: {
        title: 'Dashboard - ArtemisAds Op',
      }
    },
    {
      path: "menu",
      name: "op_menu",
      component: () => import('../pages/operator/menu/index.vue'),
      meta: {
        title: 'Menu - ArtemisAds Op',
      }
    },
    {
      path: 'invoice-pdf/:id',
      name: 'operator-invoice-pdf',
      component: () => import('../pages/operator/pdf.vue'),
      meta: {
        title: 'Finance Invoice PDF - ArtemisAds',
      }
    },
    {
      path: 'merge-pdf/:id',
      name: 'operator-merge-pdf',
      component: () => import('../pages/operator/mergePdf.vue'),
      meta: {
        title: 'Finance Invoice PDF - ArtemisAds',
      }
    },
    {
      path: "publisher",
      name: "op_Publisher",
      component: () => import('../pages/operator/publisher/index.vue'),
      meta: {
        title: 'Publisher - ArtemisAds Op',
      },
    },
    {
      path: "seller",
      name: "op_Seller",
      component: () => import('../pages/operator/seller/index.vue'),
      meta: {
        title: 'Seller - ArtemisAds Op',
      },
    },
    // {
    //   path: "seller-report",
    //   name: "op_Seller_Report",
    //   component: () => import('../pages/operator/seller/sellerReport.vue'),
    //   meta: {
    //     title: 'SellerReport - ArtemisAds Op',
    //   },
    // },
    {
      path: "commissions",
      name: "op_Commissions",
      component: () => import('../pages/operator/commissions/index.vue'),
      meta: {
        title: 'Commissions - ArtemisAds Op',
      },
    },
    {
      path: "operation/productsExport",
      name: "op_productsExport",
      component: () => import('../pages/operator/operation/productsExport/index.vue'),
      meta: {
        title: 'Products Export - ArtemisAds Op',
      },
    },
    {
      path: "operation/accBonusPrograms",
      name: "op_accBonusPrograms",
      component: () => import('../pages/operator/operation/accBonusPrograms/index.vue'),
      meta: {
        title: 'Acc Bonus Programs - ArtemisAds Op',
      },
    },
    {
      path: "operation/productsExport/create",
      name: "op_productsExportCreate",
      component: () => import('../pages/operator/operation/productsExport/create.vue'),
      meta: {
        title: 'Products Export Create - ArtemisAds Op',
      },
    },
    {
      path: "operation/manualPayments",
      name: "op_manualPayments",
      component: () => import('../pages/operator/operation/manualPayments.vue'),
      meta: {
        title: 'Manual Payments - ArtemisAds Op',
      },
    },
    {
      path: "operation/dealsInfo",
      name: "op_dealsInfo",
      component: () => import('../pages/operator/operation/dealsInfo.vue'),
      meta: {
        title: 'Deals Info - ArtemisAds Op',
      },
    },
   
    {
      path: "operation/submittedDeals",
      name: "op_submittedDeals",
      component: () => import('../pages/operator/operation/submittedDeals.vue'),
      meta: {
        title: 'submittedDeals Categories - ArtemisAds Op',
      },
    },
    {
      path: "operation/sensitive",
      name: "op_sensitive",
      component: () => import('../pages/operator/operation/sensitive.vue'),
      meta: {
        title: 'Sensitive Categories - ArtemisAds Op',
      },
    },
    {
      path: "operation/creatorConnections",
      name: "op_CreatorConnections",
      component: () => import('../pages/operator/operation/creatorConnections/index.vue'),
      meta: {
        title: 'Creator Connections - ArtemisAds Op',
      },
    },
    {
      path: "operation/sensitiveProducts",
      name: "op_sensitiveProducts",
      component: () => import('../pages/operator/operation/sensitiveProducts.vue'),
      meta: {
        title: 'Sensitive Products - ArtemisAds Op',
      },
    },
   
    {
      path: "operation/sellerLogs",
      name: "op_sellerLogs",
      // redirect: '/operator/operation/sellerLogs/attribution',
      meta: {
        title: 'Seller Logs - ArtemisAds Op',
      },
      children: [
        {
          path: "attribution",
          name: "operator-operation-sellerLogs-attribution",
          component: () => import('../pages/operator/operation/sellerLogs/attribution.vue'),
          meta: {
            title: 'Attribution - ArtemisAds Op',
          },
        },
        {
          path:'associate',
          name: "operator-operation-sellerLogs-associate",
          component: () => import('../pages/operator/operation/sellerLogs/associate.vue'),
          meta: {
            title: 'Associate - ArtemisAds Op',
          },
        },
        {
          path:'associateReports',
          name: "operator-operation-sellerLogs-associateReports",
          component: () => import('../pages/operator/operation/sellerLogs/associateReports.vue'),
          meta: {
            title: 'Associate Reports - ArtemisAds Op',
          },
        }
      ]
    },
    {
      path: "users",
      name: "op_Users",
      component: () => import('../pages/operator/users/index.vue'),
      meta: {
        title: 'Users - ArtemisAds Op',
      },
    },
    {
      path: "finance/manually-actions",
      name: "op_manuallyActions",
      component: () => import('../pages/operator/finance/manuallyActions/index.vue'),
      meta: {
        title: 'Manually Actions - ArtemisAds Op',
      },
    },
    {
      path: "finance/payments",
      name: "op_Payments",
      component: () => import('../pages/operator/finance/payments/index.vue'),
      meta: {
        title: 'Payments - ArtemisAds Op',
      },
    },
    {
      path: "finance/ar",
      name: "op_AR",
      component: () => import('../pages/operator/finance/ar/index.vue'),
      meta: {
        title: 'AR - ArtemisAds Op',
      },
    },
    {
       path: "finance/newPay",
      name: "op_newPay",
      component: () => import('../pages/operator/finance/newPay/index.vue'),
      meta: {
        title: 'New Payment - ArtemisAds Op',
      },
    },
    {
      path: "finance/ar/seller-detail",
      name: "op_AR Detail",
      component: () => import('../pages/operator/finance/ar/details.vue'),
      meta: {
        title: 'AR Detail - ArtemisAds',
      }
    },
    {
      path: "finance/payments/seller-detail/:id",
      name: "Payments Seller Detail",
      component: () => import('../pages/operator/finance/payments/sellerDetail/index.vue'),
      meta: {
        title: 'Payments Seller Detail - ArtemisAds',
      }
    },
    {
      path: "finance/payments/publisher-detail/:id",
      name: "Payments Publisher Detail",
      component: () => import('../pages/operator/finance/payments/publisherDetail/index.vue'),
      meta: {
        title: 'Payments Publisher Detail - ArtemisAds',
      }
    },
    {
      path: "finance/saas-plan",
      name: "op_SAASPlan",
      component: () => import('../pages/operator/finance/saasPlan/index.vue'),
      meta: {
        title: 'SAAS Plan - ArtemisAds Op',
      },
    },
    {
      path: "finance/transactions",
      name: "op_Transactions",
      component: () => import('../pages/operator/finance/transactions/index.vue'),
      meta: {
        title: 'Transactions - ArtemisAds Op',
      },
    },
     {
      path: "finance/publishersPaymentInfo",
      name: "op_publishersPaymentInfo",
      component: () => import('../pages/operator/finance/publishersPaymentInfo/index.vue'),
      meta: {
        title: 'Publishers Payment Info - ArtemisAds Op',
      },
    },
    {
      path: "finance/publisherPayoutData",
      name: "op_publisherPayoutData",
      component: () => import('../pages/operator/finance/publisherPayoutData/index.vue'),
      meta: {
        title: 'Publisher Payout Data - ArtemisAds Op',
      },
    },
    {
      path: "paidPlacement",
      name: "paidPlacement",
      redirect:'/operator/paidPlacement/placement',
      meta: {
        title: 'Settings "Paid Placement - ArtemisAds',
      },
      children: [
        {
          path:'placement',
          name:'op_Placement',
          component: () => import('../pages/operator/finance/placement/index.vue'),
          meta: {
            title: 'Placement - ArtemisAds Op',
          },
        },
        {
          path:'campaigns',
          name:'op_Campaigns',
          component: () => import('../pages/operator/finance/campaigns/index.vue'),
          meta: {
            title: 'Campaigns - ArtemisAds Op',
          },
        },
        {
          path:'campaigns/:id',
          name:'op_Campaigns Detail',
          component: () => import('../pages/operator/finance/campaigns/detail.vue'),
          meta: {
            title: 'Campaigns Detail - ArtemisAds Op',
          },
        }
      ]
    },
   
    {
      path: "/operator/reports",
      name: "reports",
      redirect: '/operator/reports/performance',
      meta: {
        title: 'Performance - ArtemisAds Op',
      },
      children: [
        {
          path:'performance',
          name:'reports-performance',
          component: () => import('../pages/operator/reports/performance/index.vue'),
          meta: {
            title: 'Placement - ArtemisAds Op',
          },
        },
        {
          path:'product',
          name:'reports-product',
          component: () => import('../pages/operator/reports/product/index.vue'),
          meta: {
            title: 'product - ArtemisAds Op',
          },
        },
        {
          path:'brand',
          name:'reports-brand',
          component: () => import('../pages/operator/reports/brand/index.vue'),
          meta: {
            title: 'brand - ArtemisAds Op',
          },
        },
        {
          path:'publisher',
          name:'reports-publisher',
          component: () => import('../pages/operator/reports/publisher/index.vue'),
          meta: {
            title: 'publisher - ArtemisAds Op',
          },
        },
         {
      path: "report",
      name: "reports-report",
      component: () => import('../pages/operator/seller/sellerReport.vue'),
      meta: {
        title: 'SellerReport - ArtemisAds Op',
      },
    },
      ]
    }
    // {
    //   path: "submittedDeals",
    //   name: "op_submittedDeals",
    //   component: () => import('../pages/operator/submittedDeals/index.vue'),
    //   meta: {
    //     title: 'Submitted Deals - ArtemisAds Op',
    //   },
    // }
  ]
}
